const generationSelect = document.querySelector("#generationSelect");
const variantSelect = document.querySelector("#variantSelect");
const goalGroup = document.querySelector("#goalGroup");
const goalExplainer = document.querySelector("#goalExplainer");
const wheelSizeGroup = document.querySelector("#wheelSizeGroup");
const loweredInput = document.querySelector("#loweredInput");
const bigBrakeInput = document.querySelector("#bigBrakeInput");
const guardInput = document.querySelector("#guardInput");
const factoryTyreInput = document.querySelector("#factoryTyreInput");
const targetTyreInput = document.querySelector("#targetTyreInput");

let selectedGoal = "safe";
let selectedWheelSize = "20";

function tyreDiameter(size) {
  const match = size.trim().toUpperCase().match(/^(\d{3})\/(\d{2})R(\d{2})$/);
  if (!match) return null;
  const width = Number(match[1]);
  const profile = Number(match[2]);
  const rim = Number(match[3]);
  return rim * 25.4 + 2 * (width * (profile / 100));
}

function formatMm(value) {
  return `${Math.round(value)} mm`;
}

function setOptions() {
  const currentGeneration = generationSelect.value;
  generationSelect.innerHTML = COMMODORE_DATA.map((item) => `<option value="${item.id}">${item.label}</option>`).join("");
  if (currentGeneration) generationSelect.value = currentGeneration;
  renderGoals();
  renderWheelSizes();
}

function renderGoals() {
  goalGroup.innerHTML = GOALS.map((goal) => `
    <button class="segment ${goal.id === selectedGoal ? "is-active" : ""}" type="button" data-goal="${goal.id}">${goal.label}</button>
  `).join("");
}

function renderWheelSizes() {
  wheelSizeGroup.innerHTML = WHEEL_SIZES.map((size) => `
    <button class="segment ${size.id === selectedWheelSize ? "is-active" : ""} ${Number(size.id) < 20 ? "is-reference" : "is-sales-size"}" type="button" data-wheel-size="${size.id}">
      ${size.label}
      <small>${Number(size.id) < 20 ? "Reference only" : "EA main size"}</small>
    </button>
  `).join("");
}

function selectedVehicle() {
  return COMMODORE_DATA.find((item) => item.id === generationSelect.value) || COMMODORE_DATA[0];
}

function selectedSize() {
  return WHEEL_SIZES.find((size) => size.id === selectedWheelSize) || WHEEL_SIZES[2];
}

function populateVariants(vehicle) {
  variantSelect.innerHTML = vehicle.variants.map((variant) => `<option value="${variant}">${variant}</option>`).join("");
}

function firstTyre(vehicle) {
  return vehicle.factoryTyres.split(",")[0].trim();
}

function confidence(vehicle) {
  const caution = loweredInput.checked || bigBrakeInput.checked || selectedGoal === "deep" || selectedGoal === "staggered" || selectedGoal === "stance" || selectedGoal === "walky" || selectedWheelSize === "22";
  if (caution) return { label: "EA fitment check recommended", className: "needs-check" };
  if (vehicle.id === "ve" || vehicle.id === "vf" || vehicle.id === "vt-vz") return { label: "Popular EA fitment path", className: "good" };
  return { label: "Measure before ordering", className: "watch" };
}

function goalAdvice(vehicle) {
  const size = selectedSize();
  const base = {
    safe: [
      { title: "Safe daily direction", copy: "Keep wheel width and offset close to the common Commodore range. Prioritise tyre load rating, centre bore match and simple rotation if the customer drives it daily." },
      { title: `${size.label} direction`, copy: `${size.note} A useful tyre starting point is ${size.tyre}, then EA can match width, offset and load rating to the exact car.` }
    ],
    stance: [
      { title: "Tough street stance", copy: "This is for customers who want the car to sit tougher without turning the setup into a full custom fitment. EA should balance width, offset and tyre profile so the wheel fills the guard properly." },
      { title: `${size.label} stance path`, copy: `${size.note} The final fit depends on tyre shoulder, ride height and whether the customer wants a flush look or a more conservative street fit.` }
    ],
    walky: [
      { title: "Walky / Walkinshaw-style direction", copy: "Treat Walky as a feature fitment family for Commodore customers. Start by confirming generation, brake package, wheel width, offset, tyre size and whether the customer wants square, staggered or deep dish." },
      { title: "Construction wording", copy: WALKY_FAMILY.constructionNote },
      { title: `${size.label} Walky path`, copy: selectedWheelSize === "22" ? "A 22 inch Walky setup is a premium show direction. EA can guide tyre size, guard room, brake clearance and ride height so the fitment suits the car properly." : "For Walky builds, 20 inch is the main sweet spot. Use 20x8.5 as the calmer starting point, then step into 20x9.5 or 20x10 when the customer wants a stronger rear stance." }
    ],
    deep: [
      { title: "Deep dish direction", copy: "Deep dish depends heavily on rear offset, tyre shoulder, suspension height and guard condition. Treat this as an enquiry, not an instant yes." },
      { title: "What EA should confirm", copy: "Rear guard clearance, inner strut clearance, tyre width, whether the car is lowered, and whether the customer accepts guard rolling." }
    ],
    staggered: [
      { title: "Staggered direction", copy: "A staggered setup can suit Commodores well, especially VE/VF and HSV-style builds. Front brake and rear guard clearance must be checked together." },
      { title: "Tyre pairing", copy: "Keep front and rear rolling diameter close so ABS, traction control and speedometer behaviour stays sensible." }
    ]
  };
  const extras = [];
  if (loweredInput.checked) extras.push({ title: "Lowered / coilover note", copy: "Check inner clearance at the front and rear. Coilovers can reduce room compared with factory struts." });
  if (bigBrakeInput.checked) extras.push({ title: "Big brake clearance note", copy: "Diameter alone does not prove clearance. Spoke shape, barrel shape and caliper face clearance matter, especially on HSV, Redline, Brembo or modified cars." });
  if (guardInput.checked) extras.push({ title: "Guard-friendly note", copy: "Stay conservative on offset and tyre width. Avoid promising flush or poke fitment without measuring." });
  if (selectedWheelSize === "22") extras.push({ title: "22 inch wheel note", copy: "A 22 inch Commodore fitment is a show-style direction. EA should guide tyre load rating, ride height, guard clearance and ride comfort expectations before ordering." });
  return [...base[selectedGoal], ...extras];
}

function renderGoalExplainer() {
  const goal = GOALS.find((item) => item.id === selectedGoal) || GOALS[0];
  goalExplainer.innerHTML = `
    <strong>${goal.label}</strong>
    <span>${goal.short}</span>
    <p>${goal.description}</p>
  `;
}

function renderSpecs(vehicle) {
  const size = selectedSize();
  renderStockCheck(vehicle);
  const specs = [
    ["PCD", vehicle.pcd],
    ["Centre bore", vehicle.centreBore],
    ["Factory wheels", vehicle.factoryWheels],
    ["Factory tyres", vehicle.factoryTyres],
    ["Offset guide", vehicle.offset],
    ["Nut type", vehicle.nut],
    ["Selected wheel size", size.label],
    ["Tyre starting point", size.tyre],
    ["EA sales focus", Number(size.id) < 20 ? "Reference only - guide customer toward 20 or 22 inch EA options" : "Main EA Commodore sales path"]
  ];
  document.querySelector("#factorySpecs").innerHTML = specs.map(([label, value]) => `
    <div class="spec"><span>${label}</span><strong>${value}</strong></div>
  `).join("");
}

function renderStockCheck(vehicle) {
  document.querySelector("#stockCheckCopy").textContent = `This is the kind of fitment the ${vehicle.label} was commonly brought out with from factory in stock standard form. EA uses these original-style numbers as the starting point before recommending wheel width, offset, tyres, brakes and suspension clearance.`;
  const checks = [
    ["PCD / stud pattern", vehicle.pcd, "This must match the car."],
    ["Offset / ET guide", vehicle.offset, "This controls how far the wheel sits in or out."],
    ["Centre bore", vehicle.centreBore, "This affects hub fitment and hub ring needs."],
    ["Factory tyre reference", vehicle.factoryTyres, "Use this when comparing rolling diameter."]
  ];
  document.querySelector("#stockCheckGrid").innerHTML = checks.map(([label, value, note]) => `
    <div>
      <span>${label}</span>
      <strong>${value}</strong>
      <small>${note}</small>
    </div>
  `).join("");
}

function renderTyres() {
  const factory = tyreDiameter(factoryTyreInput.value);
  const target = tyreDiameter(targetTyreInput.value);
  const tyreResult = document.querySelector("#tyreResult");
  if (!factory || !target) {
    tyreResult.innerHTML = "<p>Enter sizes like 245/35R20 to compare rolling diameter and speedometer impact.</p>";
    return;
  }
  const diff = target - factory;
  const percent = (diff / factory) * 100;
  const speedo = 100 * (target / factory);
  const status = Math.abs(percent) <= 2 ? "Good comparison range" : Math.abs(percent) <= 3 ? "Check before sale" : "High change: EA confirmation needed";
  tyreResult.innerHTML = `
    <div class="tyre-metrics">
      <div><span>Current diameter</span><strong>${formatMm(factory)}</strong></div>
      <div><span>Proposed diameter</span><strong>${formatMm(target)}</strong></div>
      <div><span>Difference</span><strong>${percent.toFixed(1)}%</strong></div>
      <div><span>When speedo reads 100</span><strong>${speedo.toFixed(1)} km/h</strong></div>
    </div>
    <p class="${Math.abs(percent) <= 2 ? "ok" : "warn"}">${status}. Confirm load rating and clearance before final sale.</p>
  `;
}

function renderProducts(vehicle) {
  const tokens = vehicle.label.replace(/[()/-]/g, " ").split(/\s+/).filter((token) => token.length >= 2);
  const products = selectedGoal === "walky"
    ? EA_PRODUCTS.filter((product) => product.family === "walky")
    : EA_PRODUCTS.filter((product) => product.family !== "walky" && (tokens.some((token) => product.fit.toLowerCase().includes(token.toLowerCase())) || product.fit.includes("VT VX VY VZ VE VF")));
  document.querySelector("#productGrid").innerHTML = products.slice(0, 4).map((product) => `
    <article class="product">
      <img src="${product.image}" alt="${product.title}" loading="lazy">
      <div>
        <h3>${product.title}</h3>
        <p>${product.notes}</p>
        <span>${product.fit}</span>
      </div>
    </article>
  `).join("");
}

function render() {
  const vehicle = selectedVehicle();
  const badge = confidence(vehicle);
  const size = selectedSize();
  document.querySelector("#resultTitle").textContent = `${vehicle.label} fitment direction`;
  document.querySelector("#resultSummary").textContent = `${variantSelect.value || vehicle.variants[0]} customer looking for ${size.label} ${GOALS.find((goal) => goal.id === selectedGoal).label.toLowerCase()}. This is a guided EA starting point so the final wheel width, offset and tyre package can suit the exact car.`;
  document.querySelector("#confidenceBadge").className = `confidence ${badge.className}`;
  document.querySelector("#confidenceBadge").textContent = badge.label;
  renderSpecs(vehicle);
  renderGoalExplainer();
  document.querySelector("#upgradeCards").innerHTML = goalAdvice(vehicle).map((item) => `
    <article class="upgrade-card">
      <h3>${item.title}</h3>
      <p>${item.copy}</p>
    </article>
  `).join("") + renderWalkySizes();
  renderTyres();
  renderProducts(vehicle);
}

function renderWalkySizes() {
  if (selectedGoal !== "walky") return "";
  return `
    <article class="upgrade-card upgrade-card--wide">
      <h3>${WALKY_FAMILY.title}</h3>
      <p>${WALKY_FAMILY.summary}</p>
      <div class="walky-size-grid">
        ${WALKY_FAMILY.sizes.map((item) => `
          <div>
            <strong>${item.size}</strong>
            <span>${item.role}</span>
            <small>${item.tyre}</small>
            <em>${item.risk}</em>
          </div>
        `).join("")}
      </div>
    </article>
  `;
}

function init() {
  setOptions();
  populateVariants(selectedVehicle());
  factoryTyreInput.value = firstTyre(selectedVehicle());
  targetTyreInput.value = selectedSize().tyre;
  function updateVehicleSelection() {
    const vehicle = selectedVehicle();
    populateVariants(vehicle);
    factoryTyreInput.value = firstTyre(vehicle);
    render();
  }

  generationSelect.addEventListener("change", updateVehicleSelection);
  generationSelect.addEventListener("input", updateVehicleSelection);
  [variantSelect, loweredInput, bigBrakeInput, guardInput, factoryTyreInput, targetTyreInput].forEach((input) => input.addEventListener("input", render));
  goalGroup.addEventListener("click", (event) => {
    const button = event.target.closest("[data-goal]");
    if (!button) return;
    selectedGoal = button.dataset.goal;
    renderGoals();
    render();
  });
  wheelSizeGroup.addEventListener("click", (event) => {
    const button = event.target.closest("[data-wheel-size]");
    if (!button) return;
    selectedWheelSize = button.dataset.wheelSize;
    targetTyreInput.value = selectedSize().tyre;
    renderWheelSizes();
    render();
  });
  render();
}

init();
